<template>
  <v-card class="rounded-card card-shadow">
    <v-card-title class="font-weight-bold pl-5 subtitle-1">
      Listagem de compras
    </v-card-title>
    <v-card-text>
      <px-indicadores-lista-compra :compras="compras"
                                   :loading="loading"
                                   :on-change-options="onChangeOptions"
                                   :options-list="optionsList"
                                   @update="onClickRefresh"/>
    </v-card-text>
  </v-card>
</template>
<script>
import paginationMixin from '@/mixins/pagination-mixin';
import IndicadoresService from '@/modules/dashboard/dashboard-service';
import IndicadoresListaCompra from './IndicadoresListaCompras.vue';

export default {
  mixins: [paginationMixin],
  props: {
    stringFilter: String,
    tipoProduto: String,
  },
  data() {
    return {
      compras: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 5,
        offset: 0,
        filter: '',
        sort: '',
        sortDesc: true,
      },
      loading: false,
      optionsList: {},
    };
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getCompras();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCompras();
    },
    onClickRefresh() {
      this.getCompras();
    },
    getCompras() {
      this.loading = true;

      const { limit, offset } = this.listOptions;
      return IndicadoresService.getComprasPage({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
        tipoProduto: this.tipoProduto || undefined,
      })
        .then((response) => {
          this.compras = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  watch: {
    stringFilter(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.listOptions.filter = this.stringFilter;
      this.getCompras();
    },
    tipoProduto(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getCompras();
    },
  },
  components: {
    PxIndicadoresListaCompra: IndicadoresListaCompra,
  },
};
</script>
